import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 40 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension}
    height={dimension}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
  >
    <mask id="mask0_24941_1363" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
      <rect width="40" height="40" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_24941_1363)">
      <path d="M18.3333 35V21.6667H5V18.3333H18.3333V5H21.6667V18.3333H35V21.6667H21.6667V35H18.3333Z" fill="#0B57D0" />
    </g>
  </svg>
);

export default Icon;
